import { useTranslation } from 'react-i18next';
import { DoughnutPlaceholderCard } from './DoughnutPlaceholderCard';

export const DoughnutSomethingWentWrongCard = () => {
  const { t } = useTranslation();
  return <DoughnutPlaceholderCard placeholder={t('common.somethingWrong')} />;
};
